import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "classes-container mx-4 mr-8" }


import {useRouter} from "vue-router";
import {ApiMap} from "@/api/type";


export default /*@__PURE__*/_defineComponent({
  __name: 'GameCards',
  props: {
    data: {},
    color: {}
  },
  setup(__props: any) {

const routers = useRouter()



return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (value, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: index,
            cols: "12",
            sm: "6",
            md: "4",
            lg: "3",
            class: "px-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "py-2",
                hover: "",
                "prepend-icon": "mdi-equalizer-outline",
                title: `${value.lastSavedAt} 保存`,
                color: _ctx.color ?? 'indigo-lighten-2',
                onClick: ($event: any) => (_unref(routers).push({path: '/board', query: {id: value.id}}))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 进行情况：" + _toDisplayString(value.status === 1 ? '进行中' : '已结束'), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, " 小组总数：" + _toDisplayString(value.teamCount), 1),
                      _createElementVNode("div", null, " 学生总数：" + _toDisplayString(value.studentCount), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["title", "color", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})